import { render } from "./index.vue?vue&type=template&id=e58f06fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e58f06fe&scoped=true&lang=less"

import exportComponent from "D:\\web\\my\\水茶花\\sch-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58f06fe"]])

export default __exports__